<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Title"
            v-model.trim="doc.title"
            type="text"
            placeholder="Functionality title"
            id="title"
          ></v-text-field>
          <v-textarea
            label="Description"
            v-model.trim="doc.description"
            type="text"
            placeholder="Functionality description"
            id="description"
          ></v-textarea>
          <v-select
            :items="dropdownCategories"
            label="Functionality Value"
            v-model.trim="doc.value"
          ></v-select>
          <v-text-field
            label="Note"
            v-model.trim="doc.note"
            type="text"
            placeholder="Notes"
            id="note"
          ></v-text-field>
          <v-select
            v-model="doc.project"
            label="Project"
            :items="refs"
            item-text="title"
            item-value="id"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");

export default {
  name: "AdminFunctionalityUpload",
  data() {
    return {
      dropdownCategories: ["5", "10", "20", "25", "30", "35", "40", "45", "50"],
      refs: [],
    };
  },
  props: {
    doc: Object,
  },
  mounted() {
    this.getRefs();
  },
  methods: {
    getRefs() {
      fb["projectsCollection"]
        .get()
        .then((docs) => {
          let refs = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            refs.push(doc);
          });
          this.refs = refs;
        })
        .catch(() => {});
    },
  },
};
</script>
